import React from 'react';
import PropTypes from 'prop-types';

import DateAndAuthor from "../../DateAndAuthor";
import LogEntryMarker from "../../LogEntryMarker";

import {black500} from 'assets/jss/main';

FeedLogEntry.propTypes = {
    feedName: PropTypes.node.isRequired,
    date: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.instanceOf(Date)]).isRequired,
    author: PropTypes.string.isRequired,
};

function FeedLogEntry({feedName, date, author}) {
    return (
        <div
            style={{
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
                width: '100%',
                marginBottom: '12px'
            }}
        >
            <LogEntryMarker />
            <div
                style={{
                    display: 'flex',
                    flex: '1 0 0',
                    minWidth: 0,
                    flexDirection: 'column',
                    justifyContent: 'center',
                    gap: '4px',
                    fontSize: '14px',
                    fontWeight: 400
                }}
            >
                <div
                    style={{
                        display: 'flex',
                        alignItems: 'flex-start',
                        justifyContent: 'space-between',
                        gap: '8px',
                        width: '100%',
                    }}
                >
                    <span style={{color: black500,  lineHeight: 'normal'}}>
                       {feedName}
                    </span>
                </div>
                <DateAndAuthor date={date} author={author} />
            </div>
        </div>
    );
}

export default FeedLogEntry;
